/**
 * ContentTabs Funktionalität mit Unterstützung für synchronisierte rechte Spalte
 */

function setActiveContentTab(contentTabs, activeId = 0){
    let contentTabsHeader = contentTabs.querySelector('.contentTabs__header');
    let contentTabsContent = contentTabs.querySelector('.contentTabs__content');

    if(contentTabsHeader && contentTabsContent){
        let contents = contentTabsContent.children;
        let contentHeaderChildren = contentTabsHeader.children;

        if(contents){
            let count = 0;
            for(let contentHeaderTab of contentHeaderChildren){
                contentHeaderTab.classList.remove("is-active");
                if(count === activeId){
                    contentHeaderTab.classList.add("is-active");
                }
                count++;
            }
            count = 0;
            for(let content of contents){
                content.classList.remove("is-active");
                if(count === activeId){
                    content.classList.add("is-active");
                }
                count++;
            }

            // Synchronisiere die rechte Spalte wenn wir in der Warenkorb-Ansicht sind
            if(contentTabs.classList.contains('basketView')) {
                syncRightColumnContent(activeId);
            }
        }
    }
}

function buildContentTabs(contentTabs){
    let contentTabsHeader = contentTabs.querySelector('.contentTabs__header');
    let contentTabsContent = contentTabs.querySelector('.contentTabs__content');

    if(contentTabsHeader && contentTabsContent){
        let contents = contentTabsContent.children;

        if(contents){
            for(let content of contents){
                content.classList.add("contentTabs__contentItem");
            }
        }
    }

    contentTabs.classList.add("initialized");
}

function getCurrentIndex(tabs, currentTab){
    let index = 0;

    for(let tab of tabs){
        if(tab === currentTab){
            return index;
        }
        index++;
    }
    
    return 0;
}

function setEventListenerForTab(contentTabs){
    let contentTabsHeader = contentTabs.querySelector('.contentTabs__header');
    if(contentTabsHeader){
        // Nur Tabs selektieren, keine Buttons
        let tabs = contentTabsHeader.querySelectorAll('.contentTabs__tab');

        // Event-Listener für Tabs
        if(tabs){
            for(let tab of tabs){
                tab.addEventListener("click", function (){
                    const tabIndex = getCurrentIndex(tabs, tab);
                    setActiveContentTab(contentTabs, tabIndex);
                });
            }
        }

        // Separaten Event-Listener für den "Neuer Warenkorb" Button
        let newBasketButton = contentTabsHeader.querySelector('button.linkWithIcon');
        if(newBasketButton) {
            newBasketButton.addEventListener("click", function(event) {
                event.preventDefault();
                // Hier später die eigene Funktion einbauen
                console.log("Neuer Warenkorb Button geklickt");

                // Wichtig: Nicht den aktiven Tab-Status ändern
                // Hier könnte später z.B. ein Modal geöffnet werden
            });
        }
    }
}


/**
 * Synchronisiert die Inhaltsanzeige in der rechten Spalte basierend auf dem aktiven Tab-Index
 */
function syncRightColumnContent(activeIndex) {
    // Finde die Content-Items in der rechten Spalte
    const rightColumnContent = document.querySelector('.col-md-5 .contentTabs__content, .col-lg-4 .contentTabs__content, .col-xlg-3 .contentTabs__content');
    
    if (rightColumnContent) {
        const contentItems = rightColumnContent.querySelectorAll('.contentTabs__contentItem');
        
        if (contentItems.length) {
            contentItems.forEach((item, index) => {
                if (index === activeIndex) {
                    item.classList.add('is-active');
                    item.style.display = 'block';
                } else {
                    item.classList.remove('is-active');
                    item.style.display = 'none';
                }
            });
        }
    }
}

/**
 * Ermöglicht die manuelle Synchronisierung der Tabs und der Inhalte in der rechten Spalte
 */
export function syncTabsWithContent(tabId) {
    // Finde den Tab mit der angegebenen ID
    const tab = document.getElementById(tabId);
    if (!tab) return;
    
    // Finde den übergeordneten contentTabs Container
    const contentTabs = tab.closest('.contentTabs');
    if (!contentTabs) return;
    
    // Finde den Tab-Header
    const tabsHeader = contentTabs.querySelector('.contentTabs__header--basket');
    if (!tabsHeader) return;
    
    // Finde alle Tabs und den Index des Ziel-Tabs
    const tabs = tabsHeader.querySelectorAll('.contentTabs__tab');
    const tabIndex = Array.from(tabs).findIndex(t => t === tab);
    
    if (tabIndex >= 0) {
        setActiveContentTab(contentTabs, tabIndex);
    }
}


export function initContentTabs(wrapper = document){
    for(let contentTabs of wrapper.querySelectorAll('.contentTabs')){
        buildContentTabs(contentTabs);

        const tabs = contentTabs.querySelectorAll('.contentTabs__tab');
        let activeIndex = 0;
        let activeTab = null;

        tabs.forEach((tab, index) => {
            if (tab.classList.contains('is-active')) {
                activeIndex = index;
                activeTab = tab;
            }
        });

        setActiveContentTab(contentTabs, activeIndex);
        setEventListenerForTab(contentTabs);

        // Rechte Spalte synchronisieren
        if(contentTabs.classList.contains('basketView')) {
            syncRightColumnContent(activeIndex);
        }

        // Aktiven Tab zentrieren
        if (activeTab) {
            const container = contentTabs.querySelector('.contentTabs__header--basket');
            const containerRect = container.getBoundingClientRect();
            const tabRect = activeTab.getBoundingClientRect();
            const scrollOffset = tabRect.left - containerRect.left - (container.clientWidth / 2) + (activeTab.clientWidth / 2);

            container.scrollBy({
                left: scrollOffset,
                behavior: 'smooth'
            });
        }
    }
}